import {Directive} from "@angular/core";

@Directive({
    selector: "[woa-page-footer-control]"
})
export class PageFooterControlDirective {
}
